import { render, staticRenderFns } from "./h5Index.vue?vue&type=template&id=5868161b&scoped=true&"
import script from "./h5Index.vue?vue&type=script&lang=js&"
export * from "./h5Index.vue?vue&type=script&lang=js&"
import style0 from "./h5Index.vue?vue&type=style&index=0&id=5868161b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868161b",
  null
  
)

export default component.exports